import React from "react";
import CustomCheckbox from "../../common/components/elements/checkbox/CustomCheckbox";
import {FieldContainer} from "../../common/components/collections/form/forms";
import {Field} from "react-final-form";
import styled from "styled-components";
import {showErrorHighlight} from "src/core/common/utils";

function SaveCheckoutInfo({allowChange = () => true, onClick, styles}) {
  function onChange(callback, value) {
    !allowChange(value) && callback(value);
  }
  return (
    <Field
      name="saveCheckoutInfo"
      render={({input, meta}) => (
        <FieldContainer>
          <Container
            data-cy="save-checkout-info"
            onClick={() => {
              onChange(input.onChange, !input.value);
              onClick(!input.value);
            }}
          >
            <CustomCheckbox
              {...input}
              color={"black"}
              type={"checkbox"}
              checked={input.value}
              onChange={() => onChange(input.onChange, !input.value)}
              styles={styles}
            />
            <Text
              onClick={() => onChange(input.onChange, !input.value)}
              hasErrors={showErrorHighlight(meta)}
            >
              Save checkout information
            </Text>
          </Container>
        </FieldContainer>
      )}
    />
  );
}

export const Container = styled.div`
  display: flex;
  font-size: ${({theme}) => theme.v2.typography.sizing.m.lg};
  line-height: 18px;
  color: #8d8d8d;
`;
const Text = styled.div`
  cursor: pointer;
  color: ${({theme}) => theme.v2.color.base.grey["900"]};
`;

export default SaveCheckoutInfo;
